import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { setAppLocale } from '@/i18n';
import { useLocaleStore, type Locale } from '@/stores/locale';

const locales: { value: Locale; label: string }[] = [
  { value: 'vi', label: 'Tiếng Việt' },
  { value: 'en', label: 'English' },
];

/** Compact locale switcher rendered in the topbar. */
export function LocaleToggle() {
  const { t } = useTranslation();
  const current = useLocaleStore((s) => s.locale);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={t('common.language')}
          title={t('common.language')}
        >
          <Globe className="h-4 w-4" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {locales.map((opt) => (
          <DropdownMenuItem
            key={opt.value}
            onSelect={() => {
              void setAppLocale(opt.value);
            }}
            data-active={current === opt.value}
            className="data-[active=true]:bg-accent"
          >
            <span className="font-mono text-xs uppercase text-muted-foreground">
              {opt.value}
            </span>
            <span>{opt.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
